import styled, { keyframes } from 'styled-components';

export const pulse = keyframes`
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.5);
  }
`;

interface IDotProps {
  index: number;
  color?: string;
}

export const Dot = styled.div<IDotProps>`
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  transform: scale(0.5);
  animation: 1s ${pulse} infinite ease-in-out;
  background-color: ${({ theme, color }) => color || theme.colors.text};
  border-radius: 5px;
  animation-delay: ${({ index }) => Math.round(index * 0.3 * 10) / 10}s;
`;

interface ILoaderContainerProps {
  backgroundColor?: string;
  over: boolean;
}

export const LoaderContainer = styled.div<ILoaderContainerProps>`
  position: ${({ over }) => over ? 'absolute' : 'relative'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.background};
  z-index: 10;
`;
